import type { IconData } from '@stacksjs/iconify-core'

export const windowMaximize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 48H40.335a24.027 24.027 0 0 0-24 24v384a24.027 24.027 0 0 0 24 24H472a24.027 24.027 0 0 0 24-24V72a24.027 24.027 0 0 0-24-24m-8 32v71.981l-415.665-.491V80ZM48.335 448V183.49l415.665.491V448Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default windowMaximize
